<h1 mat-dialog-title>Where do you work?</h1>
<div mat-dialog-content>
  <mat-card-content>
    <div class="map">
      <agm-map 
      [latitude]="mLat"
      [longitude]="mLong"
      [zoom]="zoom"
      [disableDefaultUI]="false"
      [zoomControl]="false"
      (mapClick)="mapClicked($event)">
    
      <agm-marker 
          *ngFor="let m of markers; let i = index"
          (markerClick)="clickedMarker(m.label, i)"
          [latitude]="m.lat"
          [longitude]="m.lng"
          [label]="m.label"
          [markerDraggable]="m.draggable"
          [iconUrl]="(m.status=='Y' ) ? 'http://maps.google.com/mapfiles/ms/icons/green-dot.png' : 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'"
          (dragEnd)="markerDragEnd(m, $event)">
     
        
      </agm-marker>
      </agm-map>
  </div>
  </mat-card-content>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-button  cdkFocusInitial (click)="mapLatLong()">Update</button>
</div>